import React, {useState, useContext} from "react";
import {moreProjects} from "../../portfolio";
import "./MoreProjects.scss";

import StyleContext from "../../contexts/StyleContext";

export default function MoreProjects() {
  const {isDark} = useContext(StyleContext);

  if (!moreProjects.display) {
    return null;
  }

  return (
    <div className={isDark ? "dark-mode main" : "main"} id="moreprojects">
      <div className="moreprojects-main-div">
        <div className="moreprojects-image-div">
          <img
            src={moreProjects.image}
            alt="More Projects"
            className="more-projects-image"
          />
        </div>
        <div className="moreprojects-text-div">
          <h1
            className={
              isDark ? "dark-mode moreprojects-heading" : "moreprojects-heading"
            }
          >
            {moreProjects.title}{" "}
          </h1>
          <p
            className={
              isDark
                ? "dark-mode subTitle moreprojects-text-subtitle"
                : "subTitle moreprojects-text-subtitle"
            }
            dangerouslySetInnerHTML={{__html: moreProjects.subtitle}}
          ></p>
          <button
            className={"moreprojects-button"}
            onClick={() => {
              window.location.href = moreProjects.blog;
            }}
          >
            {moreProjects.buttontext}
          </button>
        </div>
      </div>
    </div>
  );
}
